<template>
  <aside v-if="isVisible" class="promo-panel" data-testid="promo-panel">
    <img class="promo-panel__photo" :src="photo" alt="" />
    <div class="promo-panel__shade"></div>
    <div class="promo-panel__content">
      <ul class="promo-panel__cards">
        <li v-for="card in cards" :key="card.title" class="promo-panel__card">
          <span class="promo-panel__card-icon" aria-hidden="true">
            <span class="promo-panel__card-icon-placeholder"></span>
          </span>
          <div class="promo-panel__card-text">
            <p class="promo-panel__card-title">{{ card.title }}</p>
            <p class="promo-panel__card-body">{{ card.text }}</p>
          </div>
          <span class="promo-panel__check" aria-hidden="true">&#10003;</span>
        </li>
      </ul>
      <h2 class="promo-panel__headline">{{ headline }}</h2>
      <p class="promo-panel__text">{{ text }}</p>
    </div>
  </aside>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import photo from "@components/assets/login/promo-photo.jpg";

// Promo content is fixed in code and changed per release (ER-12920).
const cards = [
  {
    title: "IQ Agent",
    text: "Answers questions about exIQtive and your organization.",
  },
  {
    title: "Quizzes and inspection protocols",
    text: "Generated by IQ Agent from the context you give it.",
  },
];
const headline = "Meet IQ Agent, the organizational intelligence agent";
const text =
  "Ask questions about exIQtive and your organization, and generate quizzes and inspection protocols from the context you give it.";

const vm = getCurrentInstance().proxy;
// Hidden below the md breakpoint, as the old photo panel was.
const isVisible = computed(() => Boolean(vm.$vuetify?.breakpoint?.mdAndUp));
</script>

<style scoped>
.promo-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #101828;
}
.promo-panel__photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.promo-panel__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(16, 24, 40, 0) 0%,
    rgba(16, 24, 40, 0.1) 40%,
    rgba(16, 24, 40, 0.6) 60%,
    rgba(16, 24, 40, 0.85) 100%
  );
}
.promo-panel__content {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 720px;
  padding: 0 80px 64px;
}
.promo-panel__cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 0 24px;
  padding: 0;
  list-style: none;
}
.promo-panel__card {
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
  min-height: 80px;
  padding: 16px 20px 16px 16px;
  border-radius: 12px;
  background-color: #ffffff;
}
.promo-panel__card-icon {
  display: flex;
  flex: none;
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  padding: 8px;
  border-radius: 8px;
  background-color: #f9fafb;
}
.promo-panel__card-icon-placeholder {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: #eaecf0;
}
.promo-panel__card-text {
  flex: 1;
  min-width: 0;
}
.promo-panel__card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #101828;
}
.promo-panel__card-body {
  margin: 2px 0 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #344054;
}
.promo-panel__check {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: #218c45;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}
.promo-panel__headline {
  margin: 0 0 16px;
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  color: #ffffff;
}
.promo-panel__text {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #ffffff;
}
</style>
